<template>
  <div class="arVideo">
    <ul class="hvRlist">
      <li class="hvRlistIn" v-for="(item, index) in msg.qj" :key="index">
        <a :target="'ar' + index" :href="item.linkurl">
          <van-image
            width="14rem"
            height="14rem"
            lazy-load
            :src="item.imageurl"
          />
          <div class="hvRname">
            {{ item.title }}
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "HomeVideo",
  props: ["msg"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.arVideo{
    // height 23.75rem
    padding .9375rem 0
}
.hvRlist{
    display flex;
    justify-content space-between
}
.hvRlistIn a{
  color #000
}
.hvRlistIn:hover a{
  color rgba(255, 94, 4, 1)
}
.arVideo .hvRname{
  text-align center

}
</style>
